import type { SessionDto } from "@bafe/api-client";
import { useQuery } from "@tanstack/react-query";

import { api } from "./api";
import { queryKeys } from "./query";

export function useSession() {
	return useQuery({
		queryKey: queryKeys.session,
		queryFn: () => api.getSession(),
		retry: false,
		staleTime: 60_000,
	});
}

export function activeMembership(session: SessionDto, organisationId: string | null) {
	return (
		session.memberships.find((membership) => membership.organisationId === organisationId) ??
		session.memberships[0] ??
		null
	);
}
